import { Component, OnInit, ViewChild } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response, RequestOptions, Headers} from '@angular/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import swal from 'sweetalert2';
// declare var $ : any;

import  * as $ from "jquery"



const headers = new Headers({'Content-Type': 'application/json','Authorization': JSON.parse(localStorage.getItem("user_token"))});
const options = new RequestOptions({ headers: headers });
@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

	url = environment.url;
	user_info : any = null;
	query : any = null;
	response : any = null;

	constructor( private http : Http) { }

	ngOnInit() {
		this.getUserInfo();
	};

	getUserInfo(){
		console.log(localStorage.getItem("user_token"));
		const path = this.url + '/user/all/nonadmin'
		this.http.get(path, options)
		.subscribe(res=>{
			console.log(res.json());
			this.user_info = res.json();
		});
	};

	changeUserStatus(user_info){
		console.log(user_info.is_active);
		if (user_info.is_active){
			this.query ={
				"username" : user_info.username,
				"is_active" : false
			};
			this.http.post(this.url + "/user/status",this.query, options)
			.subscribe(res=>{
				console.log(res.json());
				this.response = res.json();
				if (this.response["status"]){
					this.getUserInfo();
				}
			});

		}
		else{
			this.query ={
				"username" : user_info.username,
				"is_active" : true
			};
			this.http.post(this.url + "/user/status",this.query, options)
			.subscribe(res=>{
				console.log(res.json());
				this.response = res.json();
				if (this.response["status"]){
					this.getUserInfo();
				}
			});

		} 
	}

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/users/users.component.ts